import React, { useMemo } from 'react'

import { PraktikKinerjaStepCard } from 'app/KinerjaShared/components/PraktikKinerjaStepCard'

import type { StepCardStatus } from 'app/KinerjaShared/components/PraktikKinerjaStepCard'
import type { StepProgressData } from 'app/KinerjaShared/components/PraktikKinerjaPegawaiStepCards/types'

type PelaksanaanTindakLanjutStepCardProps<TStep extends string = string> = {
  className?: string
  description: React.ReactNode
  imagePath: string
  lockedHint?: string
  progressData?: StepProgressData<TStep>
  sortedSteps: Array<TStep>
  step: TStep
  title: React.ReactNode
}

export function PelaksanaanTindakLanjutStepCard<TStep extends string = string>({
  className,
  description,
  imagePath,
  lockedHint = 'Dilakukan setelah isi Rencana Tindak Lanjut.',
  progressData = {},
  sortedSteps,
  step,
  title,
}: PelaksanaanTindakLanjutStepCardProps<TStep>) {
  const stepCardStatus: StepCardStatus = useMemo(() => {
    const currentStepIndex = sortedSteps.indexOf(progressData.step)
    const stepIndex = sortedSteps.indexOf(step)

    if (currentStepIndex > stepIndex) return 'completed'
    if (currentStepIndex === stepIndex) return 'active'

    return 'locked'
  }, [progressData.step, sortedSteps, step])

  return (
    <PraktikKinerjaStepCard
      className={className}
      description={description}
      iconSrc={imagePath}
      lockedHint={lockedHint}
      status={stepCardStatus}
      title={title}
    />
  )
}
